import {Injectable, inject} from '@angular/core';
import {Storage, ref, getDownloadURL} from '@angular/fire/storage';
import {environment} from '../../../../environments/environment';
import {IStorage} from '../../shared-models/storage/storage';
import {IStore} from '../../shared-models/store/store';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  private storage = inject(Storage);

  async getDocumentDownloadUrl(storage: IStorage, store: IStore): Promise<string> {
    try {
      const filePath = `${storage.folder}/${store.storeId}/${storage.document}.${storage.extension}`;
      const storageRef = ref(this.storage, filePath);
      const downloadUrl = await getDownloadURL(storageRef);
      return downloadUrl;
    } catch (error) {
      console.error('Error fetching document download URL:', error);
      throw new Error('Failed to get document download URL');
    }
  }

}
